import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Sparkles, Crown } from 'lucide-react';
import { EMOTION_STARTERS } from './constants';

const EmptyState = ({ language, isLoading, onAsk, limits, isPremium }) => {
  const starters = EMOTION_STARTERS[language] || EMOTION_STARTERS.en;
  const showUpgrade = limits && !isPremium && limits.remaining_questions <= 3;

  return (
    <div className="h-full flex flex-col items-center justify-center text-center px-4">
      <div className="w-20 h-20 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center mb-6 shadow-lg">
        <Sparkles className="w-10 h-10 text-white" />
      </div>

      <h1 className="text-3xl font-bold text-slate-800 dark:text-white mb-3">
        {language === 'es' ? '¿Qué quieres preguntar?' : 'What do you want to ask?'}
      </h1>

      <p className="text-slate-600 dark:text-slate-400 max-w-md mb-8">
        {language === 'es'
          ? 'Encuentra verdad al instante. Comprende la Palabra de Dios como nunca antes.'
          : "Find truth instantly. Understand God's Word like never before."}
      </p>

      <div className="w-full max-w-2xl mb-6" data-testid="emotion-starters">
        <p className="text-sm font-medium text-slate-600 dark:text-slate-400 mb-3">
          {language === 'es' ? '¿Cómo te sientes hoy?' : 'How are you feeling today?'}
        </p>
        <div className="flex flex-wrap gap-2 justify-center">
          {starters.map((e) => (
            <button
              key={e.label}
              onClick={() => onAsk(e.prompt)}
              data-testid={`emotion-chip-${e.label.toLowerCase()}`}
              disabled={isLoading}
              className="px-3.5 py-2 rounded-full border border-purple-200 dark:border-purple-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:bg-purple-50 dark:hover:bg-purple-900/30 hover:border-purple-400 transition-all hover:scale-[1.04] disabled:opacity-50"
            >
              <span className="mr-1.5">{e.emoji}</span>
              {e.label}
            </button>
          ))}
        </div>
      </div>

      {showUpgrade && (
        <Card className="mb-6 border-2 border-yellow-400 bg-gradient-to-r from-yellow-50 to-orange-50 dark:from-yellow-900 dark:to-orange-900">
          <CardContent className="p-4 text-center">
            <Crown className="w-8 h-8 text-yellow-600 mx-auto mb-2" />
            <p className="text-sm font-semibold text-yellow-800 dark:text-yellow-200 mb-2">
              {language === 'es'
                ? `Solo ${limits.remaining_questions} pregunta${limits.remaining_questions === 1 ? '' : 's'} restante${limits.remaining_questions === 1 ? '' : 's'} hoy`
                : `Only ${limits.remaining_questions} question${limits.remaining_questions === 1 ? '' : 's'} left today`}
            </p>
            <p className="text-xs text-yellow-700 dark:text-yellow-300 mb-3">
              {language === 'es'
                ? 'Actualiza a Lumera+ para preguntas ilimitadas y perspectivas más profundas'
                : 'Upgrade to Lumera+ for unlimited questions and deeper insights'}
            </p>
            <Button
              size="sm"
              className="bg-gradient-to-r from-yellow-400 to-orange-400 hover:from-yellow-500 hover:to-orange-500 text-white"
              onClick={() => (window.location.href = '/pricing')}
              data-testid="lumera-empty-upgrade-btn"
            >
              {language === 'es' ? 'Actualizar Ahora' : 'Upgrade Now'}
            </Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default EmptyState;
